import axios from "axios";
import {getConfig} from '../helpers/config';

export class AnprService {

	baseAPIUrl = `${getConfig()?.url}anpr`;	
	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}	

    eseguiControllo = async (bandoId) => {
		return await axios.post(`${this.baseAPIUrl}/esegui?bandoId=${bandoId}`, null)
											.then(res => res.data);
	}

    creaCampione = async (bandoId) => {
		return await axios.post(`${this.baseAPIUrl}/crea-campione?bandoId=${bandoId}`, null)
											.then(res => res.data);
	}

    eseguiControlloSingolaRichiesta = async (richiestaId) => {
		return await axios.post(`${this.baseAPIUrl}/esegui/${richiestaId}`, null)
											.then(res => res.data);
	}
}
